import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { RequestService } from '@core/services';

import { IconComponent } from '@shared/icon/icon.component';
import { ClipboardModule } from 'ngx-clipboard';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-share-link-widget',
  templateUrl: './share-link-widget.component.html',
  styleUrls: ['./share-link-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, IconComponent, ClipboardModule],
})
export class ShareLinkWidgetComponent extends AbstractPane implements OnInit {
  public copied: boolean;
  public contentUrl: string;
  private _onCopied;

  protected router = inject(Router);
  protected request = inject(RequestService);

  ngOnInit() {
    this.contentUrl = this.request.host + this.router.url;
  }

  public onCopied(event: any) {
    this.copied = true;
    this.markForCheck();

    this.clearTimeout(this._onCopied);
    this._onCopied = this.setTimeout(() => {
      this.copied = false;
      this.markForCheck();
    }, 1000);
  }

  hasContent(): boolean {
    return !!this._pane;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }
}
